import { CarouselTypeParams } from '@environment';

export const carouselTypeParams: CarouselTypeParams = {
  channel: {
    autoplay: true,
    autoplaySpeed: 4000
  },
  movies: {
    equalizeHeights: true,
    default: {
      byPage: 9,
      gap: 10,
      arrowLayout: ['top-right']
    },
    swiperConfig: {
      slidesPerView: 1,
      spaceBetween: 20,
      breakpoints: {
        576: {
          slidesPerView: 3
        },
        768: {
          slidesPerView: 4
        },
        992: {
          slidesPerView: 5
        },
        1400: {
          slidesPerView: 6
        }
      }
    },
    options: [
      {
        breakpoint: 2200,
        byPage: 6
      },
      {
        breakpoint: 1400,
        byPage: 4
      },
      {
        breakpoint: 992,
        byPage: 3
      },
      {
        breakpoint: 768,
        byPage: 2
      },
      {
        breakpoint: 576,
        byPage: 1
      }
    ],
    arrowLayout: ['top-right'],
    viewAllHeader: true,
    arrowLayoutDesing: {
      top: 6
    }
  },
  collections: {
    equalizeHeights: true
  },
  gallery: {
    default: {
      byPage: 3,
      gap: 10,
      arrowLayout: ['top-right']
    },
    options: [
      {
        breakpoint: 1200,
        byPage: 3
      },
      {
        breakpoint: 992,
        byPage: 3
      },
      {
        breakpoint: 768,
        byPage: 2
      },
      {
        breakpoint: 576,
        byPage: 1
      }
    ],
    arrowLayout: ['top-right'],
    arrowLayoutDesing: {
      top: 9
    }
  },
  videos: {
    default: {
      byPage: 3,
      gap: 10,
      arrowLayout: ['top-right']
    },
    options: [
      {
        breakpoint: 1200,
        byPage: 3
      },
      {
        breakpoint: 992,
        byPage: 3
      },
      {
        breakpoint: 768,
        byPage: 2
      },
      {
        breakpoint: 576,
        byPage: 1
      }
    ],
    arrowLayout: ['top-right'],
    arrowLayoutDesing: {
      top: 6
    }
  },
  posters: {
    default: {
      byPage: 4,
      gap: 10,
      arrowLayout: ['top-right']
    },
    options: [
      {
        breakpoint: 1400,
        byPage: 4
      },
      {
        breakpoint: 1200,
        byPage: 4
      },
      {
        breakpoint: 992,
        byPage: 3
      },
      {
        breakpoint: 768,
        byPage: 2
      },
      {
        breakpoint: 576,
        byPage: 1
      }
    ],
    arrowLayout: ['top-right'],
    arrowLayoutDesing: {
      top: 6
    }
  }
};
